export const ReviewQuestionStatus = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
} as const;

export type ReviewQuestionStatusType =
    (typeof ReviewQuestionStatus)[keyof typeof ReviewQuestionStatus];
